import React from "react";
import { AlertTriangle } from "lucide-react";
import { apiGetPengaturan, apiUpdatePengaturan, formatApiErrorDetail } from "@/lib/api";

// Owner 2026-10-16: "Wajib ACC customer sebelum produksi" per door (DTF, Jersey), on by
// default. Only the Owner can change it (the server checks; the change is audited). It applies
// to NEW transactions: orders already waiting keep needing the customer's ACC.
const PINTU = [
  ["dtf_wajib_acc_customer", "DTF", "SPK DTF baru langsung masuk antrean (masih menunggu DP / bahan bila diwajibkan), tanpa link ACC."],
  ["jersey_wajib_acc_customer", "Jersey", "Jersey baru bisa di-ACC Kasir/CS setelah checklist lengkap, tanpa persetujuan customer."],
];
export const PERINGATAN_MATI = (nama) =>
  `Matikan wajib ACC customer untuk ${nama}?\n\nRISIKO: pesanan ${nama} BARU bisa diproduksi tanpa persetujuan customer. ` +
  "Bila desain, nama, nomor, ukuran atau warna salah, customer bisa menolak dan pesanan harus dicetak ulang atas biaya toko.\n\n" +
  "Pesanan yang sudah menunggu ACC tetap menunggu ACC customer (halaman ACC atau catatan ACC WhatsApp).";

export default function WajibAccPanel() {
  const [cfg, setCfg] = React.useState(null);
  const [msg, setMsg] = React.useState(null);
  React.useEffect(() => { apiGetPengaturan().then(setCfg).catch(() => {}); }, []);
  const ubah = async (kunci, nama, v) => {
    if (!v && !window.confirm(PERINGATAN_MATI(nama))) return;
    setMsg(null);
    try {
      const c = await apiUpdatePengaturan({ [kunci]: v });
      setCfg(c);
      setMsg({ ok: true, text: v ? `${nama}: wajib ACC customer NYALA untuk transaksi baru.` : `${nama}: wajib ACC customer MATI untuk transaksi baru.` });
    } catch (e) {
      setMsg({ ok: false, text: formatApiErrorDetail(e.response?.data?.detail) || e.message });
    }
  };
  if (!cfg) return null;
  const adaMati = PINTU.some(([k]) => cfg[k] === false);
  return (
    <div data-testid="wajib-acc-panel" className="rounded-xl border border-slate-800 bg-slate-900/60 p-5 space-y-2">
      <h2 className="text-[15px] font-bold text-soq-biru-tua">Wajib ACC customer sebelum produksi</h2>
      <p className="text-xs text-slate-500">Berlaku untuk transaksi <b>baru</b>. Pesanan yang sudah menunggu ACC tetap menunggu sampai customer menyetujui (halaman ACC) atau Kasir/CS mencatat ACC lewat WhatsApp. Perubahan tercatat di audit log.</p>
      {PINTU.map(([k, nama, ket]) => (
        <label key={k} className="flex items-start gap-2 text-sm text-slate-200">
          <input type="checkbox" data-testid={`wajib-acc-${nama.toLowerCase()}`} checked={cfg[k] !== false} onChange={(e) => ubah(k, nama, e.target.checked)} className="mt-1" />
          <span>{nama} — wajib ACC customer <span className="block text-xs text-slate-500">Mati: {ket}</span></span>
        </label>
      ))}
      {adaMati && (
        <div data-testid="wajib-acc-peringatan" className="flex items-start gap-2 rounded-lg border border-red-500/40 bg-red-500/10 px-3 py-2 text-sm text-red-300">
          <AlertTriangle size={16} className="mt-0.5 shrink-0" />
          <span>Wajib ACC customer sedang MATI untuk {PINTU.filter(([k]) => cfg[k] === false).map(([, n]) => n).join(" dan ")}. Pesanan baru bisa diproduksi tanpa persetujuan customer — risiko cetak ulang bila ada kesalahan.</span>
        </div>
      )}
      {msg && <p className={`text-xs ${msg.ok ? "text-emerald-300" : "text-red-300"}`}>{msg.text}</p>}
    </div>
  );
}
